import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { BiData } from '@wix/da-bi/pkg/events';
import { DeviationResourceType } from '../../../types/deviation';
import DesktopShareModal from '../../../SharePopup/DesktopSharePopup/DesktopShareModal';
var ShareOnSocial = function (_a) {
    var deviation = _a.deviation;
    var _b = useState(false), isShareModalShown = _b[0], setIsShareModalShown = _b[1];
    var showShareModal = function () { return setIsShareModalShown(true); };
    var hideShareModal = function () { return setIsShareModalShown(false); };
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { label: t('common.share'), onClick: showShareModal, biData: BiData({
                evid: 355,
                typeid: DeviationResourceType.TIER,
                itemid: deviation.deviationId,
                deviationid: deviation.deviationId,
            }) }),
        isShareModalShown && (React.createElement(DesktopShareModal, { deviation: deviation, onRequestClose: hideShareModal }))));
};
ShareOnSocial.displayName = 'ShareOnSocial';
export default ShareOnSocial;
//# sourceMappingURL=ShareOnSocial.js.map